<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li
      *ngFor="let breadcrumb of breadcrumbs; let last = last"
      class="breadcrumb-item"
      [ngClass]="{ active: last }"
      aria-current="page">
      <ng-container *ngIf="!last">
        <a
          class="LinkBreadcrumbs text3-tipografia-govco"
          href="#"
          role="button"
          tabindex="0"
          (click)="navigate(breadcrumb.url); $event.preventDefault()"
          (keydown.enter)="navigate(breadcrumb.url)"
          (keydown.space)="navigate(breadcrumb.url)"
          [attr.aria-label]="breadcrumb.label | translate">
          {{ breadcrumb.label | translate }}
        </a>
      </ng-container>
      <ng-container *ngIf="last">
        <span class="text3-tipografia-govco">{{ breadcrumb.label | translate }}</span>
      </ng-container>
    </li>
  </ol>
</nav>
